"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindPickupPointsSearchMessage = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%'
});
const FindPickupPointsMessage = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 'bold',
  margin: theme.spacing(2.5, 0, 1.5),
  overflowWrap: 'break-word'
}));

// TODO: Get rid of this if possible

const FindPickupPointsSearchMessage = ({
  isMapLayoutShown
}) => {
  const {
    formattedSearchConfiguration
  } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.IconCircle, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Search, {})
    }), isMapLayoutShown ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FindPickupPointsMessage, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "searchMapByPostCodeOrAddress"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FindPickupPointsMessage, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "findPickUpPoints"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "searchFor"
        }), " ", ` ${formattedSearchConfiguration}`]
      })]
    })]
  });
};
exports.FindPickupPointsSearchMessage = FindPickupPointsSearchMessage;